export const getEasing = (easing: string) => {
  switch (easing) {
    case "easeOutCirc":
      return "cubic-bezier(0, 0.55, 0.45, 1)";
    case "easeOutSine":
      return "cubic-bezier(0.61, 1, 0.88, 1)";
    case "easeInOutExpo":
      return "cubic-bezier(0.87, 0, 0.13, 1)";
    default:
      return "linear";
  }
};

export const getTransform = (transition: string, easing: string) => {
  switch (transition) {
    case "fade()":
      return `transform 0s ${easing}`;
    case "top(long)":
      return "translateY(-200px)";
    case "front(200)":
      return "translateZ(200px)";
    case "bottom(short)":
      return "translateY(100px)";
    default:
      return "transform 0s linear";
  }
};
